import "amazon-connect-streams";
import React, {useCallback, useEffect, useState} from "react";
import Text from "aws-northstar/components/Text";
import Box from "aws-northstar/layouts/Box";
import Container from "aws-northstar/layouts/Container";
import ColumnLayout, { Column } from 'aws-northstar/layouts/ColumnLayout';
import Stack from 'aws-northstar/layouts/Stack';
import { API_HOST } from "../config";
import { useDestroy, useInterval } from "../hooks";
import { genLogger } from "../lib";

const name = "RealTimeMetrics";
const { log, error } = genLogger(name);

const formatData = (attr = {}) => {
  const CONTACTS_IN_QUEUE = attr.CONTACTS_IN_QUEUE;
  const OLDEST_CONTACT_AGE = millisToMinAndSec(attr.OLDEST_CONTACT_AGE);
  const CALLBACK_CONTACTS_IN_QUEUE = attr.CALLBACK_CONTACTS_IN_QUEUE;
  const CALLBACK_OLDEST_CONTACT_AGE = millisToMinAndSec(attr.CALLBACK_OLDEST_CONTACT_AGE);
  const AGENTS_AVAILABLE = attr.AGENTS_AVAILABLE;
  const AGENTS_ONLINE = attr.AGENTS_ONLINE;

  return {
    CONTACTS_IN_QUEUE,
    OLDEST_CONTACT_AGE,
    CALLBACK_CONTACTS_IN_QUEUE,
    CALLBACK_OLDEST_CONTACT_AGE,
    AGENTS_AVAILABLE,
    AGENTS_ONLINE
  };
};

const keyNameMappings = {
    CONTACTS_IN_QUEUE: 'Calls In Queue',
    OLDEST_CONTACT_AGE: 'Longest wait time',
    CALLBACK_CONTACTS_IN_QUEUE: 'Callbacks in Queue',
    CALLBACK_OLDEST_CONTACT_AGE: 'Longest callback wait time',
    AGENTS_AVAILABLE: 'Available agents',
    AGENTS_ONLINE: 'Online agents'
};

const millisToMinAndSec = (millis) => {
    const minutes = Math.floor(millis / 60000);
    const seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}

const getStatData = () =>
  fetch(API_HOST).then((res) => res.json());

const RealTimeMetrics = () => {
  const [data, setData] = useState({
    CONTACTS_IN_QUEUE: '-',
    OLDEST_CONTACT_AGE: '-',
    CALLBACK_CONTACTS_IN_QUEUE: '-',
    CALLBACK_OLDEST_CONTACT_AGE: '-',
    AGENTS_AVAILABLE: '-',
    AGENTS_ONLINE: '-'
  });

  const date = useInterval(15000);

  const onDestroy = useCallback(() => {
    try {
      log("destroyed, emptying data");
      setData({
        CONTACTS_IN_QUEUE: '-',
        OLDEST_CONTACT_AGE: '-',
        CALLBACK_CONTACTS_IN_QUEUE: '-',
        CALLBACK_OLDEST_CONTACT_AGE: '-',
        AGENTS_AVAILABLE: '-',
        AGENTS_ONLINE: '-'
      });
    } catch (e) {
      error("couldn't empty data", e);
    }
  }, []);
  useDestroy(onDestroy);

  useEffect(() => {
    let isCancelled = false;
    const asyncFunc = async () => {
      try {
        if (!isCancelled) {
            const data = await getStatData();
            if(Object.keys(data).length ===0) {
              log("Response failure from real time metrics API");
            }
            else {
              const d = formatData(data);
              setData(d);
            }
        }
      } catch (e) {
        if (!isCancelled) error(e);
      }
    };
    asyncFunc();
    return () => (isCancelled = true);
  }, [date]);

  return (
      <div>
        <Box bgcolor="#414141" color="white" fontSize="18px" textAlign="center" height="35px" padding="8px" m={0}>
         Queue Stats
        </Box>
        <Container>
          <ColumnLayout>
            <Column key="column1">
              <Stack>
                {
                  Object.keys(data).map((key, index) => {
                    return  <Text color="primary" key={index}>{keyNameMappings[key]}</Text>;
                  })
                }
              </Stack>
            </Column>
            <Column key="column2">
              <Stack>
                {
                  Object.keys(data).map((key, index) => {
                    return <Text color="primary" key={index}>{data[key]}</Text>;
                  })
                }
              </Stack>
            </Column>
          </ColumnLayout>
        </Container>
      </div>
  );
};

export default RealTimeMetrics;
